import Layout from "@layouts/withoutNaviagtion/withoutNavigationLayout";
import TaskNavigation from "@components/Tasks/task-navigation";
import "./map-vender.scss";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import {
  GetSpecificCheckpointPEComplianceTask,
  UpdateSpecificCheckpointPEComplianceTask,
} from "@services/checkpoint.service";
import { getValue } from "@utils/lodash";
import Loader from "@components/common/Loader";
import InputField from "@_common/InputRuleFeild";
import SimpleReactValidator from "simple-react-validator";
import moment from "moment";
import {
  clientAdminFileUpload,
  clientFileUpload,
} from "@services/client-list.service";
import { toast } from "react-toastify";
import TaskLicenseNavigation from "@components/Tasks/task-license-navigation";
import {
  addSpecificTaskLicenseTask,
  getSpecificTaskLicense,
  updateTaskLicenseTask,
} from "@services/license.service";
import { handleDownloadOnClick } from "@_common/downloadfile";
import _ from "lodash";
import NoAccessPage from "@components/common/NoAccess";
import { convertCurrentDate, todayDate } from "@_common/date-helpers";
import TaskDetailsCommon from "@components/common/TaskDetails";
import CustomFileUpload from "@_common/custom-file-upload";
import PromptModal from "@prompt/modal";
import { useCallbackPrompt } from "@prompt/useCallbackPrompt";
import ShowCauseNoticeNavigation from "@components/Tasks/show-cause-notice";
import {
  getShowCauseNoticeDetails,
  getSpecificShowCauseNotice,
} from "@services/causenotice.service";
import { QueryRequestHelper } from "@_common/query-request-helper";
import { getEntityGroups } from "@services/entity-mapping.service";

export default function ShowCauseNoticeDetail(props: any) {
  let params = useParams();
  let navigate = useNavigate();
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */
  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState(0);
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [data, setData] = useState({});
  const [request, setRequest] = useState<any>({
    follow_up_date: "",
    renewal_reminder_date: "",
    expiry_date: "",
    completion_date: "",
    work_status: "",
    license_number: "",
    license_status: "",
    non_compliance_reason: "",
    is_no_expiry_task: false,
    document_ids: [
      {
        id: "",
      },
    ],
  });
  const [dirtyFields, setDirtyFields] = useState<any>({
    follow_up_date: "",
    renewal_reminder_date: "",
    expiry_date: "",
    completion_date: "",
    work_status: "",
    license_number: "",
    license_status: "",
    non_compliance_reason: "",
    is_no_expiry_task: false,
    document_ids: [
      {
        id: "",
      },
    ],
  });
  const [levels] = useState([
    "level_1",
    "level_2",
    "level_3",
    "level_4",
    "level_5",
    "level_6",
    "level_7",
    "level_8",
    "level_9",
    "level_10",
  ]);
  const [uploadedDocuments, setUploadedDocuments] = useState<any>([]);
  const [complianceStatusList] = useState([
    { value: "PENDING", label: "Pending" },
    { value: "WORK_IN_PROGRESS", label: "Work In Progress" },
    { value: "COMPLIED", label: "Complied" },
    { value: "NON_COMPLIED", label: "Non Complied" },
    { value: "NOT_APPLICABLE", label: "Not Applicable" },
    { value: "PARTIALLY_COMPLIED", label: "Partially Complied" },
  ]);

  const [workStatus] = useState([
    { value: "NEW", label: "New" },
    { value: "WORK_IN_PROGRESS", label: "Work In Progress" },
    { value: "COMPLETED", label: "Completed" },
  ]);

  const [daysList, setDaysList] = useState([]);
  const [reminder_date, setReminder_date] = useState<string | number | any>(
    "1"
  );

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    if (props.permissionAPITriggered) {
      getData();
      getHeaderList();
    }
    let daysList: any = [];
    for (let i = 1; i < 31; i++) {
      daysList.push({
        value: i,
        label: i,
      });
    }
    setDaysList(daysList);
  }, [props.permissionAPITriggered]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */
  const [info, setInfo] = useState({});
  const getData = async () => {
    try {
      setLoading(true);
      let payload: any = {
        page_no: params.page_no ? parseInt(params.page_no) : 1,
        search_text: params.search_text,
        show_cause_notice_id: params.id,
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getSpecificShowCauseNotice(params.id);
      if (resp) {
        setInfo(getValue(resp, `data`, {}));
        setData(getValue(resp, `data.license`, {}));
        setRequest({
          ...request,
          follow_up_date: getValue(resp, `data.follow_up_date`, "")
            ? new Date(getValue(resp, `data.follow_up_date`, ""))
            : null,
          completion_date: getValue(resp, `data.completion_date`, "")
            ? new Date(getValue(resp, `data.completion_date`, ""))
            : null,
          expiry_date: getValue(resp, `data.expiry_date`, "")
            ? new Date(getValue(resp, `data.expiry_date`, ""))
            : null,
          compliance_status: getValue(resp, `data.compliance_status`, ""),
          license_number: getValue(resp, `data.license_number`, ""),
          work_status: getValue(resp, `data.work_status`, ""),
          license_status: getValue(resp, `data.license_status`, ""),
          non_compliance_reason: getValue(
            resp,
            `data.non_compliance_reason`,
            ""
          ),
          is_no_expiry_task: getValue(resp, `data.is_no_expiry_task`, false),
          document_ids: getValue(resp, `documents`, []),
        });
        setDirtyFields({
          ...dirtyFields,
          follow_up_date: getValue(resp, `data.follow_up_date`, "")
            ? new Date(getValue(resp, `data.follow_up_date`, ""))
            : null,
          completion_date: getValue(resp, `data.completion_date`, "")
            ? new Date(getValue(resp, `data.completion_date`, ""))
            : null,
          expiry_date: getValue(resp, `data.expiry_date`, "")
            ? new Date(getValue(resp, `data.expiry_date`, ""))
            : null,
          compliance_status: getValue(resp, `data.compliance_status`, ""),
          license_number: getValue(resp, `data.license_number`, ""),
          work_status: getValue(resp, `data.work_status`, ""),
          license_status: getValue(resp, `data.license_status`, ""),
          non_compliance_reason: getValue(
            resp,
            `data.non_compliance_reason`,
            ""
          ),
          is_no_expiry_task: getValue(resp, `data.is_no_expiry_task`, false),
          document_ids: getValue(resp, `documents`, []),
        });
        setUploadedDocuments(getValue(resp, `data.documents`, []));
        const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        const firstDate: any = getValue(resp, `data.expiry_date`, "")
          ? new Date(getValue(resp, `data.expiry_date`, ""))
          : new Date();
        const secondDate: any = getValue(resp, `data.renewal_reminder_date`, "")
          ? new Date(getValue(resp, `data.renewal_reminder_date`, ""))
          : null;
        const diffDays = Math.round(
          Math.abs((firstDate - secondDate) / oneDay)
        );
        setReminder_date(diffDays ? diffDays : 1);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  const handleSubmit = async () => {
    const formValid = simpleValidator.current.allValid();
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    } else {
      try {
        let obj = JSON.parse(JSON.stringify(request));
        var d =
          getValue(obj, `expiry_date`, "") &&
          new Date(getValue(obj, `expiry_date`, ""));
        d && d.setDate(d.getDate() - parseInt(reminder_date));

        let payload: any = {
          follow_up_date: getValue(obj, `follow_up_date`, "")
            ? todayDate(getValue(obj, `follow_up_date`, ""))
            : null,
          completion_date:
            getValue(obj, `license_status`, "") === "COMPLIED" ||
            getValue(obj, `license_status`, "") === "NON_COMPLIED" ||
            getValue(obj, `license_status`, "") === "NOT_APPLICABLE" ||
            getValue(obj, `license_status`, "") === "PARTIALLY_COMPLIED"
              ? getValue(obj, `completion_date`, "")
                ? todayDate(getValue(obj, `completion_date`, ""))
                : moment(new Date()).format("YYYY-MM-DD")
              : null,
          expiry_date: getValue(obj, `expiry_date`, "")
            ? todayDate(getValue(obj, `expiry_date`, ""))
            : null,
          work_status: getValue(obj, `work_status`, ""),
          license_number: getValue(obj, `license_number`, ""),
          license_status: getValue(obj, `license_status`, ""),
          renewal_reminder_date: getValue(obj, `renewal_reminder_date`, "")
            ? todayDate(getValue(obj, `renewal_reminder_date`, ""))
            : moment(new Date(d)).format("YYYY-MM-DD"),
          document_ids: uploadedDocuments.map((item: object) => ({
            id: getValue(item, `id`, ""),
          })),
          is_no_expiry_task: getValue(obj, `is_no_expiry_task`, false),
        };
        // Object.keys(payload).forEach((key) => {
        // 	if (!payload[key] || payload[key] === undefined) {
        // 		delete payload[key];
        // 	}
        // });
        setSubmitLoading(true);
        let resp = await updateTaskLicenseTask(params.id, payload);
        if (resp) {
          setSubmitLoading(false);
          getData();
          confirmNavigation();
          toast.success("Updated successfully");
        } else {
          setSubmitLoading(false);
        }
      } catch (error) {
        setSubmitLoading(false);
      }
    }
  };
  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */
  const handleChangeText = (e: any) => {
    const { name, value } = e.target;
    setRequest({
      ...request,
      [name]: value,
    });
  };
  const handleUploadDocumnets = async (e: any) => {
    Array.from(e.target.files).forEach(async (item: any) => {
      let formData = new FormData();
      formData.append("file", item);
      try {
        let resp = await clientAdminFileUpload(formData);
        if (resp) {
          uploadedDocuments.push(getValue(resp, `data`, {}));
          setUploadedDocuments([...uploadedDocuments]);
          e.target.value = null;
        } else {
          e.target.value = null;
        }
      } catch (error) {
        e.target.value = null;
      }
    });
  };

  const handleRemoveUploadedFiles = (id: string) => {
    let filtered = uploadedDocuments.filter(
      (item: object) => getValue(item, `id`, "") !== id
    );
    setUploadedDocuments(filtered);
  };
  /* -------------------------------------------------------------------------- */
  /*                                Prompt Section                              */
  /* -------------------------------------------------------------------------- */
  const [isChanged, setIsChanged] = useState(false);
  useEffect(() => {
    setIsChanged(
      _.isEqualWith(request, dirtyFields, (a: any, b: any) => {
        // if both are null or equal to an empty string then they are equal
        if ((_.isNull(a) || a === "") && (_.isNull(b) || b === "")) return true;
      })
    );
  });
  const [showPrompt, confirmNavigation, cancelNavigation]: any =
    useCallbackPrompt(!isChanged);

  const [lifetime, setLifetime] = useState(false);

  // ----------------- Upload section ----------------- //
  const [uploadLoading, setUploadLoading] = useState(false);
  const handleUploadDocuments = async (e: any) => {
    e.preventDefault();
    Array.from(e.target.files).forEach(async (item: any) => {
      let formData = new FormData();
      formData.append("file", item);
      // formData.append("domain_name", getValue(localStorage,`client`,''));
      try {
        setUploadLoading(true);
        let resp = await clientAdminFileUpload(formData);
        if (resp) {
          uploadedDocuments.push(getValue(resp, `data`, {}));
          setUploadedDocuments([...uploadedDocuments]);
          e.target.value = null;
          setUploadLoading(false);
        } else {
          e.target.value = null;
        }
      } catch (error) {
        e.target.value = null;
        setUploadLoading(false);
      }
    });
  };
  const handleDrop = (e: any) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files);
    files.forEach(async (item: any) => {
      let formData = new FormData();
      formData.append("file", item);
      try {
        setUploadLoading(true);
        let resp = await clientAdminFileUpload(formData);
        if (resp) {
          uploadedDocuments.push(getValue(resp, `data`, {}));
          setUploadedDocuments([...uploadedDocuments]);
          e.target.value = null;
          setUploadLoading(false);
        } else {
          e.target.value = null;
        }
      } catch (error) {
        e.target.value = null;
        setUploadLoading(false);
      }
    });
  };
  const handleDragOver = (event: any) => {
    event.preventDefault();
  };
  const disableUpload = () => {};
  const [headerObj] = useState<any>({});
  const getHeaderList = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      status: params.status ? params.status : "",
      sort_by: params.sort_by,
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      let resp = await getEntityGroups(queryRequest);
      if (resp) {
        getValue(resp, `data.entityGroups`, []).map((item: any) => {
          return (headerObj[`level_${getValue(item, `group_level`, "")}`] =
            getValue(item, `group_name`, ""));
        });
      }
    } catch (error) {}
  };
  return (
    <>
      <Layout>
        {!loading &&
        !getValue(props, `subTabPermissionList`, []).includes(
          "report_show_cause_notice"
        ) ? (
          <NoAccessPage />
        ) : (
          <>
            <PromptModal
              showDialog={showPrompt}
              confirmNavigation={confirmNavigation}
              cancelNavigation={cancelNavigation}
            />
            <ShowCauseNoticeNavigation
              id={params.id}
              handleSubmit={handleSubmit}
              submitLoading={submitLoading}
              save={true}
              isChanged={isChanged}
              permissions={props.permissions}
            />
            <div className="map-vendor-wrapper map-vendor-wrapper--task-details w-100">
              <div className="map-vendor__details map-vendor__details--task-details d-flex align-items-flex-start px-0 my-0">
                {loading || !props.permissionAPITriggered ? (
                  <Loader />
                ) : (
                  <>
                    <div className="map-vendor-wrapper w-100 mb-5">
                      <div className="map-vendor__details d-flex align-items-flex-start m-0">
                        <div className="map-vendor__check">
                          <h4 className="map-vendor__task-title mt-4">
                            Organization Information
                          </h4>
                          <div className="position-relative form-group  align-items-center cursor-pointer mb-0">
                            {levels.map((item: string, index: number) => {
                              if (getValue(info, `[${item}]`, "")) {
                                return (
                                  <div
                                    className="user-details-wrapper__form-group form-group"
                                    key={index}
                                  >
                                    <label className="checkpoint-active-details__label">
                                      {headerObj[item] && headerObj[item]}
                                    </label>
                                    <InputField
                                      inputType="TEXT"
                                      className="form-control w-100"
                                      name="license_status"
                                      id="license_status"
                                      value={getValue(
                                        info,
                                        `[${item}].entity_name`,
                                        ""
                                      )}
                                      disabled
                                      color="white"
                                    />
                                  </div>
                                );
                              }
                            })}
                          </div>
                        </div>
                        <div className="map-vendor__check">
                          <h4 className="map-vendor__task-title mt-4">
                            Notice Details
                          </h4>
                          <div className="user-details-wrapper__form-group form-group">
                            <label className="checkpoint-active-details__label">
                              Show Cause Related to
                            </label>
                            <InputField
                              inputType="TEXT"
                              className="form-control w-100"
                              name="license_status"
                              id="license_status"
                              value={getValue(
                                info,
                                `show_cause_related_to`,
                                ""
                              )}
                              disabled
                              color="white"
                            />
                          </div>

                          <div className="user-details-wrapper__form-group form-group">
                            <label className="checkpoint-active-details__label">
                              Notice Date
                            </label>
                            <InputField
                              inputType="TEXT"
                              className="form-control w-100"
                              name="license_status"
                              id="license_status"
                              value={convertCurrentDate(
                                getValue(info, `notice_dated`, "")
                              )}
                              disabled
                              color="white"
                            />
                          </div>
                          <div className="user-details-wrapper__form-group form-group">
                            <label className="checkpoint-active-details__label">
                              Received Date
                            </label>
                            <InputField
                              inputType="TEXT"
                              className="form-control w-100"
                              name="license_status"
                              id="license_status"
                              value={convertCurrentDate(
                                getValue(info, `received_on`, "")
                              )}
                              disabled
                              color="white"
                            />
                          </div>
                          <div className="user-details-wrapper__form-group form-group">
                            <label className="checkpoint-active-details__label">
                              Deadline Date
                            </label>
                            <InputField
                              inputType="TEXT"
                              className="form-control w-100"
                              name="license_status"
                              id="license_status"
                              value={convertCurrentDate(
                                getValue(info, `notice_reply_deadline`, "")
                              )}
                              disabled
                              color="white"
                            />
                          </div>
                          <div className="user-details-wrapper__form-group form-group">
                            <label className="checkpoint-active-details__label">
                              Action Taken
                            </label>
                            <InputField
                              inputType="TEXT"
                              className="form-control w-100"
                              name="license_status"
                              id="license_status"
                              value={
                                getValue(info, `action_taken`, false)
                                  ? "Yes"
                                  : "No"
                              }
                              disabled
                              color="white"
                            />
                          </div>
                          <div className="user-details-wrapper__form-group form-group">
                            <label className="checkpoint-active-details__label">
                              Responsible Person
                            </label>
                            <InputField
                              inputType="TEXT"
                              className="form-control w-100"
                              name="license_status"
                              id="license_status"
                              value={
                                getValue(
                                  info,
                                  `responsible_person.first_name`,
                                  ""
                                ) +
                                " " +
                                getValue(
                                  info,
                                  `responsible_person.last_name`,
                                  ""
                                )
                              }
                              disabled
                              color="white"
                            />
                          </div>
                          <div className="user-details-wrapper__form-group form-group">
                            <label className="checkpoint-active-details__label">
                              Reporting Person
                            </label>
                            <InputField
                              inputType="TEXT"
                              className="form-control w-100"
                              name="license_status"
                              id="license_status"
                              value={
                                getValue(
                                  info,
                                  `reporting_person.first_name`,
                                  ""
                                ) +
                                " " +
                                getValue(info, `reporting_person.last_name`, "")
                              }
                              disabled
                              color="white"
                            />
                          </div>
                          <div className="user-details-wrapper__form-group form-group">
                            <label className="checkpoint-active-details__label">
                              Remainder Date
                            </label>
                            <InputField
                              inputType="TEXT"
                              className="form-control w-100"
                              name="license_status"
                              id="license_status"
                              value={convertCurrentDate(
                                getValue(info, `remainder_required_on`, "")
                              )}
                              disabled
                              color="white"
                            />
                          </div>
                          <div className="user-details-wrapper__form-group form-group">
                            <label className="checkpoint-active-details__label">
                              Comments
                            </label>
                            <InputField
                              inputType="TEXT"
                              className="form-control w-100"
                              name="license_status"
                              id="license_status"
                              value={getValue(info, `comments`, "")}
                              disabled
                              color="white"
                            />
                          </div>
                          <div className="user-details-wrapper__form-group form-group">
                            <label className="checkpoint-active-details__label">
                              Document
                            </label>
                            <div className="attach-files-wrapper__files cursor-pointer d-flex justify-content-between">
                              <p
                                className="cursor-pointer"
                                onClick={() =>
                                  handleDownloadOnClick(
                                    getValue(info, `document.url`, ""),
                                    getValue(info, `document.name`, "")
                                  )
                                }
                              >
                                {getValue(info, `document.name.length`, "") > 30
                                  ? getValue(info, `document.name`, "")
                                      .substring(0, 30)
                                      .concat("...")
                                  : getValue(info, `document.name`, "")}
                              </p>
                              {/* {getValue(props, `permissions`, []).includes(
                                "update"
                              ) && (
                                <img
                                  src="/images/close-black.svg"
                                  className="img-fluid cursor-pointer"
                                  onClick={() =>
                                    handleRemoveUploadedFiles(
                                      getValue(info, `document.id`, "")
                                    )
                                  }
                                />
                              )} */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
              <div className="w-100 footer-wrapper--task">
                <img
                  src="/images/footer-image.svg"
                  className="img-fluid footer-image"
                />
              </div>
            </div>
          </>
        )}
      </Layout>
    </>
  );
}
